import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { actions } from '../../StockAdjustmentInBatchState'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'

export default ({
  totalAdjustments, adjustmentId, showModal, setShowModal,
}) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const cancelAdjustments = () => {
    setShowModal(false)
    dispatch(actions.cancelPendingAdjustments({ adjustmentId, history }))
  }

  return (
    <ConfirmOrRejectModal
      show={showModal}
      title='Cancelar todos os ajustes'
      description={`Você tem certeza que deseja cancelar o ajuste de ${totalAdjustments} produtos?`}
      onConfirm={cancelAdjustments}
      onReject={() => setShowModal(false)}
      onClose={() => setShowModal(false)}
    />
  )
}
